export default __webpack_public_path__ + "static/media/guia-escritorio-3.bdd365eb.png";